{
    "HeaderSidebar_ExpandMenu": "Développer le menu (Ctrl + ])",
    "HeaderSidebar_CollapseMenu": "Réduire le menu (Ctrl + [)",
    "HeaderSidebar_PinMenu": "Menu des épingles étendu",
    "HeaderSidebar_UnpinMenu": "Détacher le menu",
    "NAME": "HeaderSidebar"
}